// Generated by ui/tools/i18n.mjs from en.json. Do not edit: change the JSON and run `node ../../../packages/ui/tools/i18n.mjs compile .` in web/.
import type { Catalogue } from '@dugzi/ui';

/** Every message id this app has (t() only accepts these). */
export type MessageId =
  | "import.add"
  | "import.clear"
  | "import.destination"
  | "import.duplicate"
  | "import.history"
  | "import.jobLabel"
  | "import.limit"
  | "import.limitsUnavailable"
  | "import.next"
  | "import.noName"
  | "import.omitted"
  | "import.page"
  | "import.pages"
  | "import.previous"
  | "import.rejectedGuidance"
  | "import.remove"
  | "import.removeFor"
  | "import.repeated"
  | "import.result"
  | "import.resultFor"
  | "import.resume"
  | "import.resumeFor"
  | "import.review"
  | "import.selectAll"
  | "import.selectNew"
  | "import.state.cancelled"
  | "import.state.done"
  | "import.state.failed"
  | "import.state.partial"
  | "import.state.paused"
  | "import.state.ready"
  | "import.state.uploading"
  | "import.state.verifying"
  | "import.summary"
  | "import.tooLarge"
  | "import.unavailableBook"
  | "import.viewResult"
  | "launch.book_hint"
  | "launch.book_name"
  | "launch.book_ready"
  | "launch.new_book";

const catalogue: Catalogue = {"status":"source","messages":{"import.tooLarge":["Choose a file of ",["bytes","number"]," bytes or smaller."],"import.limitsUnavailable":["The upload limit could not be loaded. Reload this page and try again."],"import.limit":["The file size limit is ",["bytes","number"]," bytes."],"import.jobLabel":[["book"]," · ",["date"]," · Import ",["id"]],"import.unavailableBook":["Unavailable address book"],"import.destination":["Add to: ",["book"]],"import.history":["Previous file imports"],"import.resultFor":["View result for ",["label"]],"import.resumeFor":["Resume preview for ",["label"]],"import.removeFor":["Remove import for ",["label"]],"import.viewResult":["View result"],"import.resume":["Resume preview"],"import.remove":["Remove import"],"import.result":[["saved","number"]," saved; ",["skipped","number"]," could not be added."],"import.rejectedGuidance":["Contacts ",["rows"]," in the original preview were rejected. Correct their fields in your original file and upload only those contacts again. Previously saved contacts remain."],"import.review":["Review contacts"],"import.summary":[["count","plural",{"one":["#"," person"],"other":["#"," people"]}]," in the file; ",["duplicates","plural",{"0":["none look like contacts you already have."],"one":["#"," may already be in your contacts and is unticked."],"other":["#"," may already be in your contacts and are unticked."]}]],"import.omitted":["These populated fields will not be imported: ",["fields"],". Keep your original file if you need them."],"import.add":["Add ",["count","plural",{"one":["#"," person"],"other":["#"," people"]}]],"import.selectNew":["Select new contacts"],"import.selectAll":["Select all valid contacts (including duplicates)"],"import.clear":["Clear selection"],"import.pages":["Contact preview pages"],"import.previous":["Previous page"],"import.page":["Page ",["page","number"]," of ",["pages","number"]],"import.next":["Next page"],"import.noName":["No name"],"import.duplicate":["Looks like ",["name"],", already saved"],"import.repeated":["Also earlier in this file"],"import.state.done":["Added"],"import.state.partial":["Some contacts added"],"import.state.failed":["Could not complete"],"import.state.cancelled":["Cancelled"],"import.state.paused":["Ready to preview"],"import.state.verifying":["Checking file"],"import.state.uploading":["Uploading"],"import.state.ready":["Ready"],"launch.book_hint":["Only you can use this address book."],"launch.book_ready":["Your address book is ready."],"launch.new_book":["New address book"],"launch.book_name":["Contacts"]}};
export default catalogue;
